import type { JSX } from 'react';
import type { WireCitation } from '@logistics/contracts';
import { now } from '@/lib/clock';
import { sourceGlyph, sourceKindName } from '@/lib/glyphs';
import { citationAge, citationDetail } from './chat-format';

/** The "SOURCES" row under an answer: which source, what, and how fresh. */
export function Citations({ citations }: { citations: readonly WireCitation[] }): JSX.Element {
  const at = now();
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-mute font-mono text-[10px] tracking-[.08em]">SOURCES</span>
      {citations.map((c, i) => (
        <span
          key={i}
          title={citationDetail(
            c.count,
            c.sourceKind === undefined ? c.label : sourceKindName(c.sourceKind),
          )}
          className="border-line bg-surf2 inline-flex cursor-help items-center gap-1.5 rounded-md border px-2 py-[3px] text-[11.5px]"
        >
          <span className="text-acc font-mono text-[10px]">
            {c.sourceKind === undefined ? '··' : sourceGlyph(c.sourceKind)}
          </span>
          {c.label}
          <span className="text-mute">{citationAge(c.retrievedAt, at)}</span>
        </span>
      ))}
    </div>
  );
}
